import React from "react";
import socketio from "socket.io-client";
import { DASH_URI } from "../config/keys";

export const socket = socketio.connect(DASH_URI);
export const SocketContext = React.createContext();
